export const CELL_WIDTH = 204; // セルの横幅
export const CELL_HEIGHT = 41;
export const ROW_HEAD_WIDTH = 110; // 行番号の幅
export const CLOSED_SIDE_MENU_WIDTH = 76;
export const MINIMUM_RESIZE_SIDE_MENU_WIDTH = 140;
export const MAXIMUM_RESIZE_SIDE_MENU_WIDTH = 600;
export const OPEN_SIDE_MENU_WIDTH = 260;
